var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1002_3890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 9.99996C18.3334 14.6023 14.6025 18.3333 10.0001 18.3333M18.3334 9.99996C18.3334 5.39759 14.6025 1.66663 10.0001 1.66663M18.3334 9.99996C18.3334 8.61925 14.6025 7.49996 10.0001 7.49996C5.39771 7.49996 1.66675 8.61925 1.66675 9.99996M18.3334 9.99996C18.3334 11.3807 14.6025 12.5 10.0001 12.5C5.39771 12.5 1.66675 11.3807 1.66675 9.99996M10.0001 18.3333C5.39771 18.3333 1.66675 14.6023 1.66675 9.99996M10.0001 18.3333C11.841 18.3333 13.3334 14.6023 13.3334 9.99996C13.3334 5.39759 11.841 1.66663 10.0001 1.66663M10.0001 18.3333C8.15913 18.3333 6.66675 14.6023 6.66675 9.99996C6.66675 5.39759 8.15913 1.66663 10.0001 1.66663M1.66675 9.99996C1.66675 5.39759 5.39771 1.66663 10.0001 1.66663",
    stroke: "#777E90",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1002_3890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.bfb99c7dc85152365a7f39f4e6dfbd92.svg";
export { ForwardRef as ReactComponent };